<template>
        <span class="icon-wrapper" :class="{ 'muted': micMuted }">
            <i  v-if="!micMuted" class="el-icon-microphone icon" style="position: relative;" :style="{ fontSize: `${size}px` }">
                <div class="mic" :style="{ height: `${volumeIndicatorLevel>50?50:volumeIndicatorLevel}%` }"></div>
            </i>
            <i  v-else class="el-icon-turn-off-microphone" :style="{ fontSize: `${size}px` }"></i>
        </span>
</template>

<script>

export default {
    name: 'Microphone',
    components: {

    },
    props: {
        micOpen: {
            type: Boolean,
            default: false
        },
        size: {
            type: Number,
            default: 16
        },
        volumeIndicatorLevel: {
            type: Number,
            default: 10
        }
    },
    data: () => {
        return {
            micMuted: false,
            mediaStream: null,
            audioContext: null,
            analyser: null,
            dataArray: null,
            animationFrameId: null
        }
    },
   watch: {
        micOpen: {
            immediate: true,
            handler(newVal, oldVal) {
                this.micMuted = !newVal;
            }
        }   
   },
    methods: {
        toggleMic() {
            this.micMuted = !this.micMuted;
               this.$emit('toggleMic', this.micMuted);
        },
    },
    mounted() {
       
    },
    beforeUnmount() {
        
    }
}
</script>

<style lang="less" scoped>
.icon-wrapper {
    position: relative;
    display: inline-block;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #fff;
    overflow: hidden;
    
}

.icon {
    position: relative;
    overflow: hidden;
}

.mic {
    position: absolute;
    bottom: 38%;
    left: 37%;
    width: 26%;
    background-color: #00ff00;
    z-index: 1;
    border-radius: 0px 0px 4px 4px;
    transition: height 0.1s ease;
}

</style>